import { render } from "./ToDoListUserPermissionDetail.vue?vue&type=template&id=02425fc9&ts=true"
import script from "./ToDoListUserPermissionDetail.vue?vue&type=script&lang=ts"
export * from "./ToDoListUserPermissionDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__